import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";

export const hrmsSettingsApi = createApi({
  reducerPath: "hrmsSettings",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["HrmsSettings"],
  endpoints: (builder) => ({
    // Fetch HRMS settings
    getHrmsAdminSettings: builder.query({
      query: () => ({
        url: Apis.getHrmsSettings,
      }),
      providesTags: ["HrmsSettings"],
      transformResponse: (res) => res,
      keepUnusedDataFor: 180,
    }),

    // Toggle approve-based attendance
    toggleHrmsAdminSettings: builder.mutation({
      query: (value) => ({
        url: Apis.setApproveAttendanceSetting,
        method: "PATCH",
        body: { value },
      }),
      invalidatesTags: ["HrmsSettings"],
    }),
  }),
});

export const {
  useGetHrmsAdminSettingsQuery,
  useToggleHrmsAdminSettingsMutation,
} = hrmsSettingsApi;
